import {FC, useCallback, useEffect, useRef, useState} from 'react'
import {Button, message} from 'antd'
import {useNavigate} from 'react-router-dom'
import {cloneDeep} from 'lodash-es'
import {SActionBtn, SButton, SDrawer, SDrawerOrModal, SFuncModal, SLowcodeList, STableActions,} from 'shj-components'
import {
  channelChangeState,
  channelLibraryUpdateStatusById,
  channelTypeList,
  downloadRelateFiles,
  findChannelPage,
  getChannelCategoryTree,
  getCompanyList,
  getEnumList,
} from '@/services/channelManagement'
import config from './config.js'
import {AddOrEdit} from './addOrEdit'
import FluxChannelInfo from './fluxChannelInfo'
import {ModalTableDom} from './modalTable'
import {getAllDoc, getDoc, onDownLoadFile} from '@/pages/channelConfig/channelLibrary/utils.ts'
import {getAuth} from 'shj-utils'
import {authDict} from "shj-utils/dist/esm/utils";

const ChannelLibraryList: FC = () => {
  const navigate = useNavigate()
  const config_ = cloneDeep(config)
  const listRef = useRef<any>()
  const editRef = useRef<any>()
  const optionsList = useRef<any>({})

  const [visibleDrawer, setVisibleDrawer] = useState(false)
  const [loading, setLoading] = useState(false)
  const [id, setId] = useState('')
  const [type, setType] = useState('add')
  // const microAppData = window.microApp.getData()

  useEffect(() => {
  }, [])

  const fetchList = (values: any) => {
    const {current, pageSize, query} = values
    return new Promise((resolve, reject) => {
      try {
        findChannelPage({
          params: {
            pageId: current,
            pageSize,
          },
          data: {
            queryOrg: true,
            queryCategoryName: true,
            queryTypeName: true,
            ...query,
          },
        }).then(data => resolve(data))
        .catch(reject)
      } catch (e) {
        reject({success: false})
      }
    })
  }

  // 获取下拉
  const getSelection = () => {
    return new Promise(resolve => {
      Promise.all([
        channelTypeList(),
        getEnumList('com.shj.saas.plus.clue.enums.channel.ActivePassiveType'),
        getEnumList('com.shj.saas.plus.clue.enums.channel.CooperationMode'),
        getEnumList('com.shj.saas.plus.clue.enums.channel.CooperationRange'),
        getChannelCategoryTree(),
        getCompanyList(),
      ]).then(resp => {
        const obj = {
          typeOptions: resp[0],
          activePassiveTypeOptions: resp[1],
          cooperationModeList: resp[2],
          cooperationRangeList: resp[3],
          fluxTypeOptions: resp[4],
          orgOptions: [{"id": 0, "namePath": "全部组织"}, ...resp[5]],
        }
        optionsList.current = {...obj}
        resolve({...obj})
      })
    })
  }

  const onAdd = useCallback(() => {
    setType('add')
    setId('0')
    setVisibleDrawer(true)
  }, [])

  const onEdit = useCallback((record: any) => {
    setType('edit')
    setId(`${record.id}`)
    setVisibleDrawer(true)
  }, [])

  const onView = useCallback((record: any) => {
    setType('view')
    setId(`${record.id}`)
    setVisibleDrawer(true)
  }, [])

  const onMark = (record: any) => {
    SFuncModal({
      title: '渠道标记',
      footer: null,
      width: 800,
      content: <ModalTableDom data={record}/>,
    })
  }

  const onChangeState = (record: { state: string; id: string | number }) => {
    const stateVal = record.state === 'CHECKED' ? 'INVALID' : 'CHECKED'
    channelChangeState(record.id + '/' + stateVal).then(() => {
      message.success('操作成功')
      reloadFn()
    })
  }

  const goLogPage = record => {
    navigate(`/config/channelConfig/channelLibrary/logs/` + record.id);
    // microAppData.pushState(`/marketing/channelManagement/channelLibrary/logs/` + record.id)
  }

  // 刷新
  const reloadFn = () => {
    const {
      current: {reload},
    } = listRef
    reload()
  }

  const onDownLoad = useCallback(() => onDownLoadFile(downloadRelateFiles), [])

  const extension = {
    request: {fetchList, getSelection},
    events: {onAdd, onView, onEdit, onMark, onDownLoad},
    auth: authDict,
    status: {
      btnDisabled: ({selectedRowKeys}: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      actionTool(_, record: any) {
        return (
          <STableActions>
            {/* <SActionBtn auth="FlowChannelButton2" onClick={() => onEdit(record)}> */}
            <SActionBtn onClick={() => onEdit(record)}>
              修改
            </SActionBtn>
            <SActionBtn onClick={() => goLogPage(record)}>修改记录</SActionBtn>
            {record.state === 'CHECKED' || record.state === 'INVALID' ? (
              <SActionBtn
                // auth="FlowChannelButton4"
                confirm
                title={`确认让该渠道${record.state !== 'CHECKED' ? '有效' : '无效'}？`}
                onClick={() => onChangeState(record)}
              >
                {record.state === 'CHECKED' ? '无效' : '有效'}
              </SActionBtn>
            ) : (
              ''
            )}
            {/* <SActionBtn auth="FlowChannelButtonMark" onClick={() => onMark(record)}> */}
            <SActionBtn onClick={() => onMark(record)}>
              标记
            </SActionBtn>
          </STableActions>
        )
      },
      orgListRender(orgList: any[]) {
        return orgList.length <= 0 ? '' : orgList.map(item => item.namePath).join(", ")
      },
      costRangeRender(_: any, record: Record<string, any>) {
        if (record.costRangeStart && record.costRangeEnd) {
          return record.costRangeStart + " - " + record.costRangeEnd
        }
        return '-'
      },
      cooperateModeRender(text: any) {
        return getDoc(text, optionsList.current.cooperationModeList)
      },
      cooperateRangeRender(text: any) {
        return getDoc(text, optionsList.current.cooperationRangeList)
      },
      armyServicesRender(text: any) {
        return getDoc(text, optionsList.current.armyServicesTypeOptions, 'key')
      },
      activePassiveTypeRender(text: any) {
        return getDoc(text, optionsList.current.activePassiveTypeOptions, 'key')
      },
      companyListRender(text: any) {
        return getAllDoc(text, optionsList.current.orgOptions, 'code')
      },
      IDRender(id: number, record: Record<string, any>) {
        return <SActionBtn onClick={() => onView(record)}>{id}</SActionBtn>
      },
    },
  }
  const closeDrawer = () => {
    setVisibleDrawer(false)
  }
  // 是否编辑
  const isEdit = () => {
    return id && id !== '0'
  }

  const onSubmit = () => {
    if (id) {
      editRef.current?.onFinish()
      console.log(editRef.current)
    }
  }

  return (
    <>
      {/* <SLowcodeList listTitle={'渠道库管理'} config={config_} ref={listRef} {...extension} /> */}
      <SLowcodeList config={config_} ref={listRef} {...extension} />
      <SDrawerOrModal
        title={`${type !== 'view' ? (isEdit() ? '编辑' : '新增') : '详情'}`}
        onCancel={closeDrawer}
        open={visibleDrawer}
        onOk={onSubmit}
        antdProps={{[type == 'view' ? 'footer' : '']: null}}
        loading={loading}
      >
        {type !== 'view' ? (
          <AddOrEdit
              setLoading={(loading) => setLoading(loading)}
            ref={editRef}
            visibleDrawer={visibleDrawer}
            id={id}
            onClose={() => {
              closeDrawer()

              listRef.current.reload()
            }}
          />
        ) : (
          <FluxChannelInfo options={optionsList.current} visibleDrawer={visibleDrawer} id={id}/>
        )}
      </SDrawerOrModal>
    </>
  )
}

export default (props: any) => {
  return <ChannelLibraryList {...props} />
}

